import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NgrxStoreKeys } from '@warema/warema-plus/models';
import { SearchState } from './search.reducers';

const selectFeatureSearchState = createFeatureSelector<SearchState>(NgrxStoreKeys.SEARCH_FEATURE_KEY);

export const selectAllCompanies = createSelector(selectFeatureSearchState, (state: SearchState) => state.companies);

export const selectSelectedCompany = createSelector(selectFeatureSearchState, (state: SearchState) =>
    state.companies.find(x => x.addressId === state.selectedCompanyId),
);

export const selectInstantOfferValue = createSelector(
    selectFeatureSearchState,
    (state: SearchState) => state.toggleInstatOffer,
);

export const selectSelectedCompanyAddressId = createSelector(
    selectFeatureSearchState,
    (state: SearchState) => state.selectedCompanyId,
);

export const selectIsSearchRunning = createSelector(
    selectFeatureSearchState,
    (state: SearchState) => state.isSearchRunning,
);

export const selectNoSearchResults = createSelector(
    selectFeatureSearchState,
    (state: SearchState) => state.noSearchResults,
);

export const selectCanSearchMore = createSelector(
    selectFeatureSearchState,
    (state: SearchState) => state.canSearchMore,
);

export const selectLatestSearchedCoordinates = createSelector(
    selectFeatureSearchState,
    (state: SearchState) => state.latestSearchedCoordinates,
);
